"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _projectType = require("@/api/project/projectType");
var _resourceDatabaseManagement = require("@/api/resourceDatabaseManagement/resourceDatabaseManagement");
var _backMen = require("@/api/backmen/backMen");
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _index2 = require("@/api/virtualSimulationClass/index");
var _school = require("@/api/school/school");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FileUpload: _fileUpload.default,
    fileUpload: _index.default
  },
  data: function data() {
    return {
      schoolListData: [],
      accept: ".png,.jpg,.pdf",
      prolist: [],
      //专业大类
      courseList: [],
      // 课程来源
      typeList: [],
      // 类型
      List: [],
      //项目级别
      courseLevelList: ['国家级', '省级', '校级'],
      industryList: [],
      //产业分类
      industryCategoryList: [],
      //行业门类
      courseTypeList: [],
      // 资源库类别
      appliTypeList: [],
      // 应用类型
      mediaTypeList: [],
      // 媒体类型
      form: {
        courseEmceeName: '',
        courseName: "",
        //课程名称
        courseImage: "",
        //课程封面
        studyNum: "",
        //学习人数
        schoolId: "",
        //学校
        fkCourseMajor: "",
        //专业大类
        courseLink: "",
        //课程链接
        origin: "",
        // 来源
        courseLevel: "",
        //项目级别
        sort: "",
        //排序
        industryDetail: "",
        // 行业门类
        industry: "",
        // 产业分类
        provinceId: this.$store.getters.provinceId,
        courseType: '14',
        checkStatus: '1'
      },
      rules: {
        courseEmceeName: [{
          required: true,
          message: "请选择主持教师。",
          trigger: "change"
        }],
        courseName: [{
          required: true,
          message: "请输入项目名称。",
          trigger: "blur"
        }],
        freeLoginLink: [{
          required: true,
          message: "此项不能为空",
          trigger: "blur"
        }, {
          type: 'url',
          message: '请输入以http://或https://开头的网址',
          trigger: ['blur', 'change']
        }],
        courseLink: [{
          required: true,
          message: "此项不能为空",
          trigger: "blur"
        }, {
          type: 'url',
          message: '请输入以http://或https://开头的网址',
          trigger: ['blur', 'change']
        }],
        // courseSource:[{ required: true, message: "此项不能为空", trigger: "blur" }],
        schoolId: [{
          required: true,
          message: "此项不能为空",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    getSchool: function getSchool() {
      var _this = this;
      (0, _school.schoolList)({
        bureauId: '',
        queryValue: '',
        type: 0,
        pageSize: 999999,
        pageNum: 1
      }).then(function (res) {
        var data = res.data;
        _this.schoolListData = data.list;
      });
    },
    isnumber: function isnumber(val) {
      val = val.replace(/[^0-9]/gi, "");
      // 此处还可以限制位数以及大小
      return val;
    },
    // 获取课程来源
    getCourseList: function getCourseList() {
      var _this2 = this;
      (0, _resourceDatabaseManagement.courseList)({
        name: "",
        pageNum: "",
        pageSize: "",
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        console.log("//", res);
        _this2.courseList = res.data;
      });
    },
    // 课程封面
    successUpLoad: function successUpLoad(e) {
      // console.log('e',e)
      // this.form.uploadFile = e;
      this.form.courseImage = e.ossOriUrl;
    },
    // 提交
    submit: function submit(v) {
      var _this3 = this;
      // console.log(this.form);
      if (this.$store.state.user.userInfo.roleType == 3) {
        this.form.schoolId = this.$store.state.user.userInfo.schoolId;
      }
      this.$refs[v].validate(function (valid) {
        if (valid) {
          (0, _index2.resourceUpload)(_this3.form).then(function (res) {
            if (res.code === 2000) {
              _this3.$message.success("操作成功。");
              _this3.$router.push("/virtualSimulationClass/index");
            }
          });
        }
      });
      console.log(this.form);
    },
    // 返回
    isBack: function isBack() {
      this.$router.push("/virtualSimulationClass/index");
    }
  },
  created: function created() {
    var _this4 = this;
    this.getSchool();
    // 获取专业大类
    (0, _projectType.categoriesList)({
      pageNum: 1,
      pageSize: 999999,
      provinceId: this.$store.getters.provinceId,
      type: ""
    }).then(function (res) {
      _this4.prolist = res.data.list;
    });
    // 课程来源
    this.getCourseList();
    // 类型
    this.typeList = this.$store.getters.wResourceType;
    // 项目级别
    this.List = this.$store.getters.wProjectLevel;
    // 资源库类别
    this.courseTypeList = this.$store.getters.wProfessionalResourceLibraryType;
    // 应用类型
    this.appliTypeList = this.$store.getters.wApplicationType;
    // 媒体类型
    this.mediaTypeList = this.$store.getters.wMediaType;
    // 行业门类
    this.industryCategoryList = this.$store.getters.wIndustryCategory;
    // 产业分类
    // this.form.industryClassification = this.$store.getters.wIndustryType.name
    this.industryList = this.$store.getters.wIndustryType;
  }
};